import { render, staticRenderFns } from "./IgnoreList.vue?vue&type=template&id=5e8a6f0a&"
import script from "./IgnoreList.vue?vue&type=script&lang=js&"
export * from "./IgnoreList.vue?vue&type=script&lang=js&"
import style0 from "./IgnoreList.vue?vue&type=style&index=0&id=5e8a6f0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports